module.exports = __webpack_public_path__ + "static/media/hylylogo.ac08f262.svg";